import Cookie from 'js-cookie';
import AppConfig from '../domain/AppConfig';
import UrlUtil from '../util/UrlUtil';

const aperzaJpSubdomains = [
  AppConfig.APERZA_SEARCH,
  AppConfig.APERZA_NEWS,
  AppConfig.APERZA_ID,
  AppConfig.APERZA_ACCOUNT,
];

const aperzaJpSubdomain = {
  'www': {
    serviceType: AppConfig.APERZA_SEARCH,
  },
  'ec': {
    serviceType: AppConfig.APERZA_EC,
  },
  'news': {
    serviceType: AppConfig.APERZA_NEWS,
  },
  'id': {
    serviceType: AppConfig.APERZA_ID,
  },
  'account': {
    serviceType: AppConfig.APERZA_ACCOUNT,
  },
  'order': {
    serviceType: AppConfig.APERZA_ORDER,
  },
  'business': {
    serviceType: AppConfig.APERZA_BIZ,
  },
};

// const aperzaComSubdomains = [
//   AppConfig.APERZA_ORDER,
//   AppConfig.APERZA_BIZ,
// ];

const aperzaComSubdomain = {
  'www': {
    serviceType: AppConfig.APERZA_SEARCH,
  },
  'ec': {
    serviceType: AppConfig.APERZA_EC,
  },
  'order': {
    serviceType: AppConfig.APERZA_ORDER,
  },
  'business': {
    serviceType: AppConfig.APERZA_BIZ,
  },
  'id': {
    serviceType: AppConfig.APERZA_ID,
  },
  'account': {
    serviceType: AppConfig.APERZA_ACCOUNT,
  },
};


const aperzaCatalogPathPrefixes = [
  '/catalog',
  '/modal',
  '/company',
  '/product',
  '/feature',
  '/download',
  '/trends',
  '/search',
  '/aboutus',
];

export default class AppConfigService {

  static getHref() {
    return window.location.href;
  }

  static getDomain() {
    return window.location.hostname.toLowerCase();
  }

  static getPath() {
    return window.location.pathname.toLowerCase();
  }

  static getOrigin() {
    if (!window.location.origin) {
      window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
    }

    let origin = window.location.origin;
    return origin;
  }

  static isSsl() {
    return window.location.protocol === "https:";
  }

  static shouldInitLogRocket(viewer) {
    let domain = AppConfigService.getDomain();
    let path = AppConfigService.getPath();

    if (UrlUtil.getUrlParameter('logrocket')==='test') {
      return true;
    }

    if (!viewer || !viewer.isLogRocket) {
      return false;
    }

    let allowedDomains = [
      'ec.aperza.com',
      'order.aperza.com'
    ];

    if (
      allowedDomains.includes(domain) ||
      (domain === 'id.aperza.com' && path.includes('/login/aperza-order')) ||
      (domain === 'business.aperza.com' && path.includes('/signup/index.html')) ||
      (domain === 'business.aperza.com' && path.includes('/signup/action/register')) ||
      (domain === 'business.aperza.com' && path.includes('/signup/complete.html')) ||
      (domain === 'www.aperza.com' && path.includes('/feature2/'))
    ) {
      return true;
    } else {
      return false;
    }

    // if (domain.startsWith('www.aperza.com') || UrlUtil.getUrlParameter('logrocket')==='test') {
    //   return (
    //     !path.includes('/mfr/') &&
    //     !path.includes('/dst/ec/') &&
    //     !path.includes('/c/') &&
    //     !path.includes('/d/o/') &&
    //     !path.includes('/catalog/first/') &&
    //     !path.includes('/catalog/second/') &&
    //     !path.includes('/catalog/third/') &&
    //     !path.includes('/catalog/fourth/') &&
    //     !path.includes('/company/area/') &&
    //     !path.includes('/search/index/')
    //   )
    // } else {
    //   return false;
    // }
  }

  static getEnvironment() {
    let domain = AppConfigService.getDomain();
    if (domain.indexOf('.local.') > -1) {
      return AppConfig.ENV_LOCAL;
    } else if (domain.indexOf('.test.') > -1) {
      return AppConfig.ENV_TEST;
    } else if (domain.indexOf('.stg.') > -1) {
      return AppConfig.ENV_STG;
    } else if (domain.indexOf('.local.') > -1) {
      return AppConfig.ENV_LOCAL;
    } else {
      return AppConfig.ENV_PROD;
    }
  }

  static getApiHostname() {
    let env = this.getEnvironment();

    if (env === AppConfig.ENV_LOCAL) {
      return AppConfig.API_HOST_LOCAL;
    } else if (env === AppConfig.ENV_TEST) {
      return AppConfig.API_HOST_TEST;
    } else if (env === AppConfig.ENV_STG) {
      return AppConfig.API_HOST_STG;
    } else {
      return AppConfig.API_HOST_PROD;
    }
  }


  static getServiceType() {
    let domain = AppConfigService.getDomain();
    let path = AppConfigService.getPath();
    if (domain.endsWith('.aperza.jp')) {
      for(let subdomain in aperzaJpSubdomain) {
        //console.log('getServiceType subdomain', subdomain);
        if (domain.startsWith(subdomain)) {
          let domainObject = aperzaJpSubdomain[subdomain];
          return domainObject.serviceType;
        }
      }
    } else if (domain.endsWith('.aperza.com')) {
      for(let subdomain in aperzaComSubdomain) {
        if (domain.startsWith(subdomain)) {
          return aperzaComSubdomain[subdomain].serviceType;
        }
      }
    }

    return undefined;
  }

  static getLangSwitchUrl(langCode) {
    let env = AppConfigService.getEnvironment();
    let searchWebHost = AppConfigService.getSearchWebHost(env);
    if (this.isAperzaCatalog()) {
      if (langCode=='en') {
        return `${searchWebHost}/${langCode}${UrlUtil.getPath()}${UrlUtil.getSearch()}`;
      } else {
        let path = `${UrlUtil.getPath()}${UrlUtil.getSearch()}`;
        if (path.startsWith('/en')) {
          path = path.substring('/en'.length);
        }
        return `${searchWebHost}${path}`;
      }
    } else {
      //return UrlUtil.replaceOrAddUrlParameterToHref('lang', langCode);
      let targetLangCode = 'ja';
      if (langCode=='en') {
        targetLangCode = 'en';
      }

      let path = `${UrlUtil.getPath()}${UrlUtil.getSearch()}`;
      if (path.startsWith('/en') || path.startsWith('/ja')) {
        path = `/${targetLangCode}` + path.substring('/en'.length);
      } else {
        path = `/${targetLangCode}` + path;
      }

      if (path.endsWith('/ja') || path.endsWith('/ja/')) {
        path = '';
      }

      if (this.isAperzaMarketplace()) {
        return `${AppConfigService.getMarketplaceWebHost(env)}${path}`;
      } else {
        return `${searchWebHost}${path}`;
      }


    }
  }

  static isAperzaAccountDomain() {
    return AppConfigService.getServiceType() == AppConfig.APERZA_ACCOUNT;
  }

  static isAperzaIdDomain() {
    return AppConfigService.getServiceType() == AppConfig.APERZA_ID;
  }

  static isAperzaOrderDomain() {
    return AppConfigService.getServiceType() == AppConfig.APERZA_ORDER;
  }

  static isAperzaBusinessDomain() {
      return AppConfigService.getServiceType() == AppConfig.APERZA_BIZ;
    }

  static isAperzaNewsDomain() {
      return AppConfigService.getServiceType() == AppConfig.APERZA_NEWS;
  }

  static isAperzaSearch() {
    return AppConfigService.getServiceType() == AppConfig.APERZA_SEARCH;
  }

  static isAperzaCatalog() {
    if (AppConfigService.getServiceType() === AppConfig.APERZA_SEARCH) {
      let domain = AppConfigService.getDomain();
      let path = AppConfigService.getPath();
      for(let pathPrefix of aperzaCatalogPathPrefixes) {
        //console.log('getServiceType', subdomain, path, pathPrefix)
        if (path.startsWith(pathPrefix) || path.startsWith(`/en${pathPrefix}`)) {
          return true;
        }
      }
    }
    return false;
  }

  static isAperzaCatalogTop() {
    if (AppConfigService.isAperzaCatalog()) {
      let path = AppConfigService.getPath();
      if (path) {
        return path.endsWith('/catalog') || path.endsWith('/catalog/') || path.endsWith('/en/catalog/') || path.endsWith('/en/catalog/')
      }

    }
    return false;
  }

  static isOrderCheckout() {
    if (AppConfigService.isAperzaOrderDomain()) {
      let path = AppConfigService.getPath();
      if (path) {
        return path.startsWith('/checkout/confirm')
          || path.startsWith('/checkout/shipping')
          || path.startsWith('/checkout/payment')
          || path.startsWith('/checkout/invoice')
      }
    }
    return false;
  }

  static isOrderRegister() {
    if (AppConfigService.isAperzaOrderDomain()) {
      let path = AppConfigService.getPath();
      if (path) {
        return (path.startsWith('/register') || path.startsWith('/member')) && !path.endsWith("completed.html");
      }
    }
    return false;
  }

  static isBusinessSignup() {
    if (AppConfigService.isAperzaBusinessDomain()) {
      let path = AppConfigService.getPath();
      if (path) {
        return path.indexOf('/signup/') !== -1;
      }
    }
    return false;
  }

  static isBusinessOrders() {
    if (AppConfigService.isAperzaBusinessDomain()) {
      let path = AppConfigService.getPath();
      if (path) {
        return path.indexOf('/f/order') !== -1;
      }
    }
    return false;
  }


  static isAperzaMarketplace() {
    if (AppConfigService.getServiceType() === AppConfig.APERZA_EC) {
      let domain = AppConfigService.getDomain();
      return domain.startsWith('ec.');
    }
    return false;
  }

  //TODO to be merge with the same method in AppService
  static isMainPage() {
    let pathName = window.location.pathname;
    return pathName === '/' ||
      pathName === '/en' ||
      pathName === '/en/' ||
      pathName.startsWith('/en/?') ||
      pathName === '/ja' ||
      pathName === '/ja/' ||
      pathName.startsWith('/ja/?')
      ;
  }

  static isAperzaSearchResultPage() {
    if (AppConfigService.getServiceType() === AppConfig.APERZA_SEARCH) {
      let path = AppConfigService.getPath();
      if (path.includes('/s/model') || path.includes('/s/catalog') || path.includes('/s/item')) {
        return true;
      }
    }
    return false;
  }

  static isAperzaSearchCatalogResultPage() {
    if (AppConfigService.getServiceType() === AppConfig.APERZA_SEARCH) {
      let path = AppConfigService.getPath();
      if (path.includes('/s/catalog')) {
        return true;
      }
    }
    return false;
  }

  static isAperzaCompanyPage() {
    if (AppConfigService.getServiceType() === AppConfig.APERZA_SEARCH) {
      let path = AppConfigService.getPath();
      if (path.includes('/new_catalog/page') || path.match(/\/co\/([0-9].*)/) || path.match(/\/co\/([a-z1-9].*)\/catalog\/([1-9-].*)/)) {
        return true;
      }
    }
    return false;
  }

  static isAperzaSearchItemResultPage() {
    if (AppConfigService.getServiceType() === AppConfig.APERZA_SEARCH) {
      let path = AppConfigService.getPath();
      if (path.includes('/s/item')) {
        return true;
      }
    }
    return false;
  }

  static isAperzaSearchNewsResultPage() {
    if (AppConfigService.getServiceType() === AppConfig.APERZA_SEARCH) {
      let path = AppConfigService.getPath();
      if (path.includes('/s/news')) {
        return true;
      }
    }
    return false;
  }

  static getBaseDomain(env) {
    let baseDomain = '.aperza.jp';
    if (env && env.length>0) {
      return `.${env}${baseDomain}`
    } else {
      return baseDomain;
    }
  }

  static getBaseComDomain(env) {
    let baseDomain = '.aperza.com';
    if (env && env.length>0) {
      return `.${env}${baseDomain}`
    } else {
      return baseDomain;
    }
  }

  static getTokenKey(env) {
    let key = 'atkn';
    if (env && env.length>0) {
      return `${env}${key}`
    } else {
      return key;
    }
  }

  static getLangKey(env) {
    let key = 'al';
    if (env && env.length>0) {
      return `${env}${key}`
    } else {
      return key;
    }
  }

  static getLangCode(env = AppConfigService.getEnvironment()) {
    if (AppConfigService.isAperzaIdDomain() || AppConfigService.isAperzaAccountDomain() || AppConfigService.isAperzaOrderDomain()) {
      // only japanese language
      return 'ja'
    } else if (AppConfigService.isAperzaCatalog()) {
      if (AppConfigService.getPath().startsWith('/en')) {
        return 'en';
      } else {
        return 'ja';
      }
    } else {
      //APERZA.locale is generated by search-web
      let langCode = 'ja';
      if (window && window.APERZA && window.APERZA.locale) {
        langCode = APERZA.locale;
      } else {
        let key = AppConfigService.getLangKey(env);
        langCode = Cookie.get(key);
      }

      if (langCode) {
        return langCode;
      } else {
        return 'ja';
      }
    }
  }

  static getBaseCluezMemberDomain(env) {
    if (env && env.length>0) {
      if (env == 'stg') {
        return 'member.stg2.cluez.biz';
      }
      return `member.${env}.cluez.biz`
    } else {
      return 'member.cluez.biz';
    }
  }

  static getCdnHost(env) {
    if (env && env.length>0) {
      // static-local-aperza-com s3 bucket looking.
      if (env === 'local') {
        if( process.env.NODE_ENV === "local" ){
          return `//static.${env}.aperza.com:4000`;
        }
      }
      return `//static.${env}.aperza.com`
    } else {
      return '//static.aperza.com';
    }
  }

  static getSearchWebHost(env) {
    if (env && env.length>0) {
      if (env === AppConfig.ENV_LOCAL) {
        return `//www.${env}.aperza.com:8080`;
      }
      return `//www.${env}.aperza.com`;
    } else {
      return '//www.aperza.com';
    }
  }

  static getCloudPartnerHost(env) {
    if (env && env.length>0) {
      if (env === AppConfig.ENV_LOCAL) {
        return `https://cloud.${env}.aperza.com:18071/partner`;
      }
      return `//cloud.${env}.aperza.com/partner`;
    } else {
      return '//cloud.aperza.com/partner';
    }
  }

  static getAccountWebHost(env) {
    if (env && env.length>0) {
      return `//account.${env}.aperza.com`;
    } else {
      return '//account.aperza.com';
    }
  }

  static getAperzaIdHost(env) {
    if (env && env.length>0) {
      if (env === AppConfig.ENV_LOCAL) {
        return `//id.${env}.aperza.com:8000`;
      }
      return `//id.${env}.aperza.com`;
    } else {
      return '//id.aperza.com';
    }
  }

  static getAperzaAccountHost(env) {
    if (env && env.length>0) {
      return `//account.${env}.aperza.com`;
    } else {
      return '//account.aperza.com';
    }
  }

  static getMarketplaceWebHost(env) {
    if (env && env.length>0) {
      return `//ec.${env}.aperza.com`;
    } else {
      return '//ec.aperza.com';
    }
  }

  static getAutomationNewsUrl(env) {
    if (env && env.length>0) {
      return `//www.${env}.automation-news.jp`
    } else {
      return '//www.automation-news.jp';
    }
  }

  static getEnvLocaleBalloon(serviceType, env) {
    if (env && env.length>0 && serviceType) {
      let prefix = serviceType;
      if (prefix.endsWith('-aperza')) {
        prefix = prefix.substring(0, prefix.indexOf('-aperza'));
      }
      return `${prefix}-${env}`;
    } else {
      return undefined;
    }
  }

  static isSearchModel() {
    let path = AppConfigService.getPath();
    return path.includes('/s/model');
  }

  static isSearchItem() {
    let path = AppConfigService.getPath();
    return path.includes('/s/item');
  }

  static isSearchCatalog() {
    let path = AppConfigService.getPath();
    return path.includes('/s/catalog');
  }

  static isSearchNews() {
    let path = AppConfigService.getPath();
    return path.includes('/s/news');
  }

  static shouldShowMarketplaceTopBanner() {
    let domain = AppConfigService.getDomain();
    let path = AppConfigService.getPath();
    return (
      path.startsWith('/marketplace/index.html') ||
      path.endsWith('/marketplace/') ||
      (domain.startsWith('ec.') && path.endsWith('/')) ||
      (domain.startsWith('ec.') && path.endsWith('/en/')) ||
      (domain.startsWith('ec.') && path.endsWith('/en')) ||
      (domain.startsWith('ec.') && path.includes('/error-search/')) ||
      path.startsWith('/marketplace/event/') ||
      path.includes('/dst/mp/') ||
      path.includes('/d/i/') ||
      path.includes('/s/item/') ||
      path.endsWith('/mfr/index.html')
    )
  }

  static getSearchKeyword() {
    return UrlUtil.getUrlParameter('k');
  }

  /**
   *
   * @param whitelist optional whitelist for valid param names
   * @returns {{}} object whose property is the param name
   */
  static getSearchParams(whitelist = []) {
    let search = location.search;
    if (search.startsWith('?') && (AppConfigService.isSearchModel||AppConfigService.isSearchCatalog)) {
      let q = {};
      search.substring(1).split('&').forEach(function(i){
        let val = i.split('=')[1];
        val = decodeURIComponent(val);
        val = val.replace('+', ' ');
        let param = i.split('=')[0];
        if (whitelist.length == 0 || whitelist.includes(param)) {
          q[i.split('=')[0]]=val;
        }
      });
      return q;
    }
    return {};
  }

  static appConfig() {
    let appConfig = new AppConfig();
    let env = AppConfigService.getEnvironment();
    appConfig.env = env;
    appConfig.baseDomain = AppConfigService.getBaseDomain(env);
    appConfig.baseComDomain = AppConfigService.getBaseComDomain(env);
    appConfig.tokenKey = AppConfigService.getTokenKey(env);
    appConfig.langKey = AppConfigService.getLangKey(env);
    appConfig.langCode = AppConfigService.getLangCode(env);
    appConfig.baseCluezMemberDomain = AppConfigService.getBaseCluezMemberDomain(env);
    appConfig.cdnHost = AppConfigService.getCdnHost(env);
    appConfig.serviceType = AppConfigService.getServiceType();
    appConfig.isAperzaCatalog = AppConfigService.isAperzaCatalog();
    appConfig.isAperzaCatalogTop = AppConfigService.isAperzaCatalogTop();
    appConfig.isAperzaMarketplace = AppConfigService.isAperzaMarketplace();
    appConfig.isAperzaSearchItemResultPage = AppConfigService.isAperzaSearchItemResultPage();
    appConfig.isAperzaSearchCatalogResultPage = AppConfigService.isAperzaSearchCatalogResultPage();
    appConfig.hideProductCategory = appConfig.isAperzaCatalog;
    appConfig.envLocaleBalloon = AppConfigService.getEnvLocaleBalloon(appConfig.serviceType, env);
    appConfig.searchWebHost = AppConfigService.getSearchWebHost(env);
    appConfig.accountWebHost = AppConfigService.getAccountWebHost(env);
    appConfig.marketplaceWebHost = AppConfigService.getMarketplaceWebHost(env);
    appConfig.automationNewsUrl = AppConfigService.getAutomationNewsUrl(env);
    appConfig.isAperzaIdDomain = AppConfigService.isAperzaIdDomain();
    appConfig.isAperzaAccountDomain = AppConfigService.isAperzaAccountDomain();
    appConfig.isAperzaOrderDomain = AppConfigService.isAperzaOrderDomain();
    appConfig.isOrderCheckout = AppConfigService.isOrderCheckout();
    appConfig.isAperzaBusinessDomain = AppConfigService.isAperzaBusinessDomain();

    appConfig.aperzaIdHost = AppConfigService.getAperzaIdHost(env);
    appConfig.aperzaAccountHost = AppConfigService.getAperzaAccountHost(env);

    if(AppConfigService.isAperzaMarketplace()) {
      appConfig.mainPage = appConfig.marketplaceWebHost;
    } else if(AppConfigService.isAperzaCatalog()) {
      appConfig.mainPage = appConfig.searchWebHost + '/catalog';
    } else {
      appConfig.mainPage = appConfig.searchWebHost;
    }

    if (appConfig.langCode != 'ja') {
      appConfig.mainPage = appConfig.mainPage + '/' + appConfig.langCode + '/';
    }

    return appConfig;

  }


  /**
  * resolves configurations per domain
  */
  static resolveHeaderConfigurations() {

    if ( AppConfigService.isAperzaMarketplace() ) {
      // verify marketplace first as the service is both APERZA_SEARCH for different domains
      return AppConfigService.resolveHeaderConfigurationsEc();

    } else if ( AppConfigService.isAperzaCatalogTop() ) {
      // verify catalog first, as service for catalog is also APERZA_SEARCH
      return AppConfigService.resolveHeaderConfigurationsCatalog();

    } else if ( AppConfigService.isAperzaSearch() ) {

      return AppConfigService.resolveHeaderConfigurationsSearch();

    } else if ( AppConfigService.isAperzaIdDomain() ) {

      return AppConfigService.resolveHeaderConfigurationsId();

    } else if ( AppConfigService.isAperzaAccountDomain()  ) {

      return AppConfigService.resolveHeaderConfigurationsAccount();

    } else if ( AppConfigService.isAperzaOrderDomain() ) {

      return AppConfigService.resolveHeaderConfigurationsOrder();

    } else if ( AppConfigService.isAperzaBusinessDomain() ) {

        return AppConfigService.resolveHeaderConfigurationsBusiness();

    } else if ( AppConfigService.isAperzaNewsDomain() ) {

        return AppConfigService.resolveHeaderConfigurationsNews();

    } else {
      // Default to search config
      return AppConfigService.resolveHeaderConfigurationsSearch();
    }
  }

  static resolveHeaderConfigurationsSearch() {
    let config = AppConfigService.defaultHeaderConfigurations()

    return Object.assign(config, {
        disableSuggest: AppConfigService.isMainPage()
      });
  }

  static resolveHeaderConfigurationsEc() {
    let config = AppConfigService.defaultHeaderConfigurations()

    return Object.assign(config, {
        disableSuggest: AppConfigService.isMainPage(),
        disableNavCategory: false,
        disableNavCatalog: true,
        disableNavMarketplace: true,
        disableNavNews: true,
        disableNavExhibitions: true,
        disableNavManufacturers: false,
        disableNavShops: false,
        disableMarketplaceBanner: false
      });
  }

  static resolveHeaderConfigurationsCatalog() {
    let config = AppConfigService.defaultHeaderConfigurations()

    return Object.assign(config, {
        disableSuggest: true
    });
  }

  static resolveHeaderConfigurationsId() {
    return AppConfigService.defaultHeaderConfigurations();
  }

  static resolveHeaderConfigurationsAccount() {
    return AppConfigService.defaultHeaderConfigurations();
  }

  static resolveHeaderConfigurationsOrder() {

    let config = AppConfigService.defaultHeaderConfigurations()

    if ( AppConfigService.isOrderCheckout() || AppConfigService.isOrderRegister()) {
      return Object.assign(config, {
        // disable all
        disableSuggest: true,
        disableCartBadge: true,
        disableLogin: true,
        disableNavBar:true,
        disableNavCategory: true,
        disableNavCatalog: true,
        disableNavMarketplace: true,
        disableNavNews: true,
        disableNavExhibitions: true,
        disableNavManufacturers: true,
        disableNavShops: true,
        disableNavPromote: true,
        disableNavRegisterAccount: true
      });
    } else {
        // any other order page
      return Object.assign(config, {
        disableNavCategory: false,
        disableNavCatalog: true,
        disableNavMarketplace: true,
        disableNavNews: true,
        disableNavExhibitions: true,
        disableNavManufacturers: false,
        disableNavShops: false,
        disableMarketplaceBanner: false,
      });
    }
  }


  static resolveHeaderConfigurationsBusiness() {

    let config = AppConfigService.defaultHeaderConfigurations()

    if ( AppConfigService.isBusinessSignup() ) {
      return Object.assign(config, {
        // disable all
        disableSuggest: true,
        disableCartBadge: true,
        disableLogin: true,
        disableNavBar:true,
        disableNavCategory: true,
        disableNavCatalog: true,
        disableNavMarketplace: true,
        disableNavNews: true,
        disableNavExhibitions: true,
        disableNavManufacturers: true,
        disableNavShops: true,
        disableNavPromote: true,
        disableNavRegisterAccount: true
      });

    } else {
        // any other order page
      return Object.assign(config, {
        disableNavCategory: false,
        disableNavCatalog: true,
        disableNavMarketplace: true,
        disableNavNews: true,
        disableNavExhibitions: true,
        disableNavManufacturers: false,
        disableNavShops: false,
        disableMarketplaceBanner: false,
      });
    }
  }

  static resolveHeaderConfigurationsNews() {
    let config = AppConfigService.resolveHeaderConfigurationsSearch()

    return Object.assign(config, {
      disableNavBar: true,
    });
  }

  static defaultHeaderConfigurations() {
    return {
        disableSuggest: false,
        disableCartBadge: false,
        disableLogin: false,
        disableNavBar:false,
        disableNavCategory: false,
        disableNavCatalog: false  ,
        disableNavMarketplace: false,
        disableNavNews: false,
        disableNavExhibitions: false,
        disableNavManufacturers: true,
        disableNavShops: true,
        disableNavPromote: false,
        disableNavRegisterAccount: false,
        disableMarketplaceBanner: true
    }
  }
}
